<template lang="pug">
v-container.px-0.mx-0
  validation-observer(
    ref="obs"
    v-slot="{ invalid, handleSubmit }"
  )
    //- p.text-center Оставшаяся сумма для оплаты:
    //- validation-provider(
    //-   :rules="`required|max_value:${contract.maxPayment}`"
    //-   name='"Введите сумму платежа"'
    //-   vid="title"
    //-   v-slot="{ errors, valid }"
    //- )
    v-text-field(
      v-model="discount"
      label="Введите сумму скидки"
      type="number"
      prefix="₽"
      filled
      rounded
    )
    v-row.ma-0
      v-spacer
      v-btn(
        block
        color="success"
        @click="saveMethod(discount)"
      ) Установить скидку

</template>

<script>
export default {
  props: {
    saveMethod: { type: Function, required: true },
  },
  data() {
    return {
      discount: null,
    };
  },
};
</script>
